import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3702d2b8"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["onClick"];
const _hoisted_2 = {
    key: 0,
    class: "app-notifications__notification__title"
};
const _hoisted_3 = { class: "app-notifications__notification__text" };
import { computed } from 'vue';
import { useStore } from 'vuex';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Notifications',
    props: {
        delay: { default: 3000 }
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const getNotifications = computed(() => store.getters['notifications/getNotifications'] ?? []);
        const removeNotification = (item) => store.dispatch('notifications/removeNotification', item);
        const destroyNotification = (item) => {
            clearTimeout(item.timer);
            void removeNotification(item);
        };
        const delayedNotifications = computed(() => {
            return getNotifications.value.map((notification) => {
                const delay = notification.delay || props.delay;
                return {
                    ...notification,
                    timer: setTimeout(() => {
                        destroyNotification(notification);
                    }, delay),
                };
            });
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_TransitionGroup, {
                name: "app-notifications",
                tag: "ul",
                class: "app-notifications list-unstyled"
            }, {
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(delayedNotifications.value, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                            key: item.date,
                            class: "app-notifications__item'"
                        }, [
                            _createElementVNode("div", {
                                class: _normalizeClass({
                                    'app-notifications__notification': true,
                                    [`app-notifications__notification--${item.type}`]: item.type,
                                }),
                                onClick: ($event) => (removeNotification(item))
                            }, [
                                (item.title)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(item.title), 1))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_3, _toDisplayString(item.text), 1)
                            ], 10, _hoisted_1)
                        ]));
                    }), 128))
                ], undefined, true),
                _: 1
            }));
        };
    }
});
